import { render, staticRenderFns } from "./AdvStorage.vue?vue&type=template&id=2ab4cbc8&scoped=true&"
import script from "./AdvStorage.vue?vue&type=script&lang=js&"
export * from "./AdvStorage.vue?vue&type=script&lang=js&"
import style0 from "./AdvStorage.vue?vue&type=style&index=0&id=2ab4cbc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab4cbc8",
  null
  
)

export default component.exports